module.exports = __webpack_public_path__ + "img/223.problem_sink_blockage.ab1cbd81.svg";